import * as React from "react";
import PropTypes from "prop-types";

class MTableActions extends React.Component {
  render() {
    if (this.props.actions) {
      return <div style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center'
      }
      }>
        {this.props.actions.map((action, index) => (
          <this.props.components.Action
            action={action}
            key={"action-" + index}
            data={this.props.data}
            size={this.props.size}
            disabled={this.props.disabled}
          />
        ))}
      </div>
    }

    return null;
  }
}

MTableActions.defaultProps = {
  actions: [],
  data: {},
};

MTableActions.propTypes = {
  components: PropTypes.object.isRequired,
  actions: PropTypes.array.isRequired,
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]),
  disabled: PropTypes.bool,
  size: PropTypes.string,
};

export default MTableActions;